import script from "./third-party-drone.vue?vue&type=script&setup=true&lang=ts"
export * from "./third-party-drone.vue?vue&type=script&setup=true&lang=ts"

import "./third-party-drone.vue?vue&type=style&index=0&id=5e2f7ea6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e2f7ea6"]])

export default __exports__